import React from "react";
import Layout from "./Components/Layout";
import styles from "./styles/InnerPage.module.css";

export default function AboutUs() {
  return (
    <Layout title="About us | MyChineseHoroscope.com" description="Learn about MyChineseHoroscope.com and what we offer.">
      <div className={styles.page}>
        <div className={styles.container}>
          <header className={styles.hero}>
            <p className={styles.kicker}>MyChineseHoroscope.com</p>
            <h1 className={styles.h1}>About us</h1>
            <p className={styles.sub}>
              Discover your Chinese Zodiac sign, element influences, and compatibility insights—made simple and culturally authentic.
            </p>
          </header>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>What we offer</h2>
            <p className={styles.p}>
              MyChineseHoroscope helps you explore the Chinese Zodiac and Chinese Astrology through clear explanations and practical insights.
              Enter your birthday to instantly:
            </p>

            <div className={styles.grid2}>
              <div>
                <ul className={styles.list}>
                  <li>Identify your Chinese Zodiac sign</li>
                  <li>Discover your elemental influence</li>
                  <li>Understand Yin and Yang polarity</li>
                </ul>
              </div>
              <div>
                <ul className={styles.list}>
                  <li>Explore compatibility and best matches</li>
                  <li>Learn personality strengths and challenges</li>
                  <li>Access easy-to-understand astrology content</li>
                </ul>
              </div>
            </div>

            <div className={styles.divider} />

            <p className={styles.p}>
              Whether you’re new to Chinese Astrology or have a lifelong interest, we provide guidance you can actually use.
            </p>
          </section>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Why it matters</h2>
            <p className={styles.p}>
              Rooted in the lunar calendar, your zodiac sign and element can influence personality traits, relationship dynamics, timing, and decision-making.
            </p>

            <ul className={styles.list}>
              <li>Make more informed personal and professional decisions</li>
              <li>Improve self-awareness and emotional intelligence</li>
              <li>Strengthen relationships with compatibility insights</li>
              <li>Choose auspicious timing for key life events</li>
              <li>Support your environment with Feng Shui principles</li>
            </ul>
          </section>

          <section className={styles.card}>
            <h2 className={styles.sectionTitle}>Our approach</h2>
            <p className={styles.p}>
              We keep the experience fast, friendly, and accurate—designed for modern users while respecting tradition.
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}